import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxBlotterFilterCondition } from "../../bfx-blotter-filter/bfx-blotter-filter.constants";

import { BfxFindFilterConditionValueParseType } from "./BfxFindFilterConditionValueParseType";
import { BfxFindFilterOperatorSet } from "./BfxFindFilterOperatorSet";
import { BfxFindFilterConditionLabels } from "./BfxFindFilterConditionLabels";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { BfxFindFilterConditionData } from "./BfxFindFilterConditionData";
import { BfxFindFilterDateComparitor } from "../../../shared/cubiq-services/model/find/BfxFindFilterDateComparitor";
import {
  BfxAutocompleteGenericModel,
  BfxOrderEntryTimeControlModel,
} from "../../bfx-interface-controls/models/bfx-interface-controls.models";
import { BFX_FIND_DATE_COMPARITOR } from "app/bfx-find/bfx-find-date-comparitor.constants";
import { VALIDATE_TIME_PATTERN } from "../../bfx-interface-controls/bfx-time-input.component";

//export const UNSET_FILTER_OPERATOR = { label: " ", value: null};// original
export const UNSET_FILTER_OPERATOR = { label: " ", value: null };

export class BfxFindFilterCondition extends BfxBlotterFilterCondition {
  static templateId: number = -1;

  public implictOperator: boolean = false;

  // autocomplete update on blur
  public input = new BfxFindFilterConditionData();
  public calendar = new BfxFindFilterConditionData();

  // avoid templating while expanding
  public hasRowExpanded: boolean = false;

  // tab helpers
  public proxyTabSelector: Function | null = null;
  public proxyTabValue: Function | null = null;
  public proxyTabTo: Function | null = null;

  // special handling for problematic dropdown component
  private ngModelInputCalendar = false;

  private id: number = BfxFindFilterCondition.templateId++;

  public showTooltip = {
    value: false,
    from: false,
    to: false,
  };

  constructor(
    public readonly parentIndex: number,
    public readonly index: number,
    public readonly fieldName: string,
    public fieldTitle: string,
    public availableOperators: BfxFindFilterOperatorSet = BfxFindFilterOperatorSet.Equal,
    public parseType: BfxFindFilterConditionValueParseType = BfxFindFilterConditionValueParseType.None,
    public invalidValuePossible: boolean = false,
    public partialValuePossible: boolean = false,
  ) {
    super(fieldName, fieldTitle, null, null);

    if (BfxFindFilterConditionValueParseType.DateEquality === this.parseType) {
      this.ngModelInputCalendar = true;
    }
  }

  public get hasOperator() {
    // 0th enum
    return this.operator !== null;
  }

  public isInvalidBfxOrderEntryTimeControlModel(model: BfxOrderEntryTimeControlModel) {
    if (model instanceof BfxOrderEntryTimeControlModel) {
      return (
        (model != null &&
          VALIDATE_TIME_PATTERN.test(model.timeValue) &&
          model.timezoneValue == null) ||
        (model.timezoneValue != null && model.timezoneValue.value == null) ||
        model.timeValue == null ||
        (VALIDATE_TIME_PATTERN.test(model.timeValue) == false &&
          model.timezoneValue != null &&
          model.timezoneValue.value != null)
      );
    }
    return false;
  }

  public get hasInvalidValue() {
    if (!this.invalidValuePossible) return false;

    let valueInvalid = this.isInvalidBfxOrderEntryTimeControlModel(this.value);
    let fromInvalid = this.isInvalidBfxOrderEntryTimeControlModel(this.from);
    let toInvalid = this.isInvalidBfxOrderEntryTimeControlModel(this.to);

    if (valueInvalid || fromInvalid || toInvalid) {
      return true;
    } else if (this.invalidValuePossible) {
      return false;
    }

    return false;
  }

  public get hasPartialValue() {
    if (!this.partialValuePossible) return this.hasValue;

    if (this.value instanceof BfxOrderEntryTimeControlModel) {
      return (
        (this.value.timeValue != null && VALIDATE_TIME_PATTERN.test(this.value.timeValue)) ||
        (this.value.timezoneValue != null && this.value.timezoneValue.value != null)
      );
    } else if (
      this.from instanceof BfxOrderEntryTimeControlModel ||
      this.to instanceof BfxOrderEntryTimeControlModel
    ) {
      return (
        ((this.from.timeValue != null && VALIDATE_TIME_PATTERN.test(this.from.timeValue)) ||
          (this.from.timezoneValue != null && this.from.timezoneValue.value != null)) &&
        ((this.to.timeValue != null && VALIDATE_TIME_PATTERN.test(this.to.timeValue)) ||
          (this.to.timezoneValue != null && this.to.timezoneValue.value != null))
      );
    }

    return this.hasValue;
  }

  public get hasValue() {
    if (this.value instanceof BfxOrderEntryTimeControlModel) {
      return (
        this.value.timeValue != null &&
        VALIDATE_TIME_PATTERN.test(this.value.timeValue) &&
        this.value.timezoneValue != null &&
        this.value.timezoneValue.value != null
      );
    } else if (
      this.from instanceof BfxOrderEntryTimeControlModel ||
      this.to instanceof BfxOrderEntryTimeControlModel
    ) {
      return (
        this.from instanceof BfxOrderEntryTimeControlModel &&
        this.from.timeValue != null &&
        VALIDATE_TIME_PATTERN.test(this.from.timeValue) &&
        this.from.timezoneValue != null &&
        this.from.timezoneValue.value != null &&
        this.to instanceof BfxOrderEntryTimeControlModel &&
        this.to.timeValue != null &&
        VALIDATE_TIME_PATTERN.test(this.to.timeValue) &&
        this.to.timezoneValue != null &&
        this.to.timezoneValue.value != null
      );
    }

    // account for dropboxes empty array.
    if (Array.isArray(this.value)) {
      return this.value.length > 0;
    }

    // account for from/to
    return (
      (this.value !== null && this.value !== "") ||
      (this.to !== null && this.to !== "" && this.from !== null && this.from !== "")
    );
  }

  public get operator() {
    if (this.operatorData && CubiqTS.Operator[this.operatorData.value]) {
      return this.operatorData.value;
    }

    return null;
  }

  public set operator(value) {
    if (BfxFindFilterConditionLabels[value]) {
      this.operatorData = Object.assign({}, BfxFindFilterConditionLabels[value]);
    } else {
      this.operatorData = Object.assign({}, UNSET_FILTER_OPERATOR);
    }
  }

  public toString() {
    if (Array.isArray(this.value)) {
      // TO sort, we convert options to objects with label and lowerCaseLabel,
      // Sort by lcLabel
      // then join on the label
      const items = this.value
        .filter((value) => value != null && typeof value.label === "string")
        .map((valueItem) => {
          return { label: valueItem.label, lcLabel: valueItem.label.toLowerCase() };
        });
      const sortedItems = items.sort((a, b) =>
        a.lcLabel < b.lcLabel ? -1 : a.lcLabel > b.lcLabel ? 1 : 0,
      );
      const sortedLabelStr = sortedItems.map((item) => item.label).join(", ");
      return sortedLabelStr;
    }

    if (this.value instanceof Date) {
      return CubiqTS.moment(this.value).format("DD MMM YYYY");
    }

    return this.value;
  }

  public saveData(): any {
    let data = {
      fieldName: this.fieldName,
      operator: this.operator,
      from: null,
      to: null,
      value: null,
      type: null,
    };

    if (this.hasValue) {
      if (this.value !== null) {
        data.type = this.jsonType(this.value);
      } else if (this.to !== null && this.from !== null) {
        let fromType = this.jsonType(this.from);
        if (fromType === this.jsonType(this.to)) {
          data.type = fromType;
        }
      }
      if (data.type === "FixingTime") {
        data.value = JSON.stringify(this.value);
        data.to = JSON.stringify(this.to);
        data.from = JSON.stringify(this.from);
      } else {
        if (Array.isArray(this.value)) {
          const arrValue = this.value.map((valueItem) => {
            return {
              type: valueItem.type,
              label: valueItem.label,
              value: valueItem.findValue ?? valueItem.value,
            };
          });
          data.value = arrValue;
        } else {
          data.value = this.value;
          data.to = this.to;
          data.from = this.from;
        }
      }
    }

    return data;
  }

  public restoreData(data: any) {
    if (data.fieldName !== this.fieldName) {
      logger.out.info(`${this.constructor.name}: ignoring invalid type`);
      return;
    }

    this.operator = data.operator;
    this.input.operator = BfxFindFilterConditionLabels[data.operator];

    if (data.type === null && Array.isArray(data.value) && data.value.length > 0) {
      let isLongValues =
        Object.prototype.hasOwnProperty.call(data.value[0], "value") &&
        Object.prototype.hasOwnProperty.call(data.value[0].value, "low") &&
        Object.prototype.hasOwnProperty.call(data.value[0].value, "high") &&
        Object.prototype.hasOwnProperty.call(data.value[0].value, "unsigned");

      if (isLongValues) {
        try {
          this.value = data.value.map((a) => {
            a.value = CubiqTS.Long.fromValue(a.value);
            return a;
          });
        } catch (e) {
          logger.out.info(`${this.constructor.name}: failed to restore CubiqTS.Long prototype`);
          this.value = data.value;
        }

        this.from = data.from;
        this.to = data.to;
      } else {
        this.value = data.value;
        this.from = data.from;
        this.to = data.to;
      }
    } else if (data.type === null) {
      this.value = data.value;
      this.from = data.from;
      this.to = data.to;

      if (this.ngModelInputCalendar) {
        if (data.value != null) {
          this.input.value = BFX_FIND_DATE_COMPARITOR[BfxFindFilterDateComparitor[data.value]];
        }
        if (data.from != null) {
          this.input.from = BFX_FIND_DATE_COMPARITOR[BfxFindFilterDateComparitor[data.from]];
        }
        if (data.to != null) {
          this.input.to = BFX_FIND_DATE_COMPARITOR[BfxFindFilterDateComparitor[data.to]];
        }

        this.calendar.value = null;
        this.calendar.from = null;
        this.calendar.to = null;
      }
    } else if (data.type === "FixingTime") {
      if (data.value != null) {
        this.input.value = data.value != null ? JSON.parse(data.value) : null;
        this.input.from = data.from != null ? JSON.parse(data.from) : null;
        this.input.to = data.to != null ? JSON.parse(data.to) : null;

        if (this.input.value != null) {
          this.input.value = Object.assign(new BfxOrderEntryTimeControlModel(), this.input.value);
          this.input.value.timezoneValue = Object.assign(
            new BfxAutocompleteGenericModel(),
            this.input.value.timezoneValue,
          );
        }

        this.value = this.input.value;

        if (this.input.from != null) {
          this.input.from = Object.assign(new BfxOrderEntryTimeControlModel(), this.input.from);
          this.input.from.timezoneValue = Object.assign(
            new BfxAutocompleteGenericModel(),
            this.input.from.timezoneValue,
          );
        }
        this.from = this.input.from;

        if (this.input.to != null) {
          this.input.to = Object.assign(new BfxOrderEntryTimeControlModel(), this.input.to);
          this.input.to.timezoneValue = Object.assign(
            new BfxAutocompleteGenericModel(),
            this.input.to.timezoneValue,
          );
        }
        this.to = this.input.to;
      }
    } else if (data.type === "Date") {
      if (data.value) {
        this.value = new Date(data.value);
        this.from = null;
        this.to = null;

        if (this.ngModelInputCalendar) {
          this.calendar.value = new Date(data.value);
          this.calendar.from = null;
          this.calendar.to = null;
        }
      } else if (data.from && data.to) {
        this.value = null;
        this.from = new Date(data.from);
        this.to = new Date(data.to);

        if (this.ngModelInputCalendar) {
          this.calendar.value = null;
          this.calendar.from = new Date(data.from);
          this.calendar.to = new Date(data.to);
        }
      }

      if (this.ngModelInputCalendar) {
        this.input.value = null;
        this.input.from = null;
        this.input.to = null;
      }
    } else if (data.type === "BigNumber") {
      if (data.value) {
        this.value = new CubiqTS.BigNumber(data.value);
        this.from = null;
        this.to = null;
      } else if (data.from && data.to) {
        this.value = null;
        this.from = new CubiqTS.BigNumber(data.from);
        this.to = new CubiqTS.BigNumber(data.to);
      }
    }
  }

  private jsonType(value): string | null {
    if (value !== null) {
      if (value instanceof Date) {
        return "Date";
      } else if (value instanceof CubiqTS.BigNumber) {
        return "BigNumber";
      } else if (
        Object.prototype.hasOwnProperty.call(value, "timeValue") &&
        Object.prototype.hasOwnProperty.call(value, "timezoneValue")
      ) {
        return "FixingTime";
      }

      return null;
    }
  }
}
